import { Routes } from '@angular/router';
import { moduleConfig } from 'src/app/core/models/module-config';

export const adminBlogRoutes: Routes = [
    {
        path: $localize`:@@adminBlogPath:blog`,
        loadComponent: () => import('src/app/rokezzz/blog/admin/views/blog/blog.component').then(module => module.RokezzzBlogViewComponent),
        data: {
            path: 'admin.blog',
        },
        children: [
            {
                path: $localize`:@@adminPostListPath:wpisy`,
                loadComponent: () => import('src/app/rokezzz/blog/admin/views/blog/post-list/post-list.component').then(module => module.RokezzzBlogPostListViewComponent),
                data: {
                    path: 'admin.blog.post',
                    postFormPath: 'admin.blog.postForm',
                    frontPostPath: 'blog.post',
                    reviewPath: 'admin.blog.review',
                    blogType: undefined,
                    isCategory: moduleConfig.blogHasCategory,
                    isReview: moduleConfig.blogHasReview,
                }
            },
            {
                path: $localize`:@@adminPostFormPath:formularz-wpisu`,
                loadComponent: () => import('src/app/rokezzz/blog/admin/views/blog/post-form/post-form.component').then(module => module.RokezzzBlogPostFormViewComponent),
                data: {
                    path: 'admin.blog.postForm',
                    postListPath: 'admin.blog.post',
                    isCategory: moduleConfig.blogHasCategory,
                    blogType: undefined,
                }
            },
            {
                path: $localize`:@@adminPostFormPath:formularz-wpisu` + '/:id',
                loadComponent: () => import('src/app/rokezzz/blog/admin/views/blog/post-form/post-form.component').then(module => module.RokezzzBlogPostFormViewComponent),
                data: {
                    path: 'admin.blog.postForm',
                    postListPath: 'admin.blog.post',
                    isCategory: moduleConfig.blogHasCategory,
                    blogType: undefined,
                }
            },
            ...(moduleConfig.blogHasCategory ? [
                {
                    path: $localize`:@@adminCategoryListPath:kategorie`,
                    loadComponent: () => import('src/app/rokezzz/blog/admin/views/blog/category-list/category-list.component').then(module => module.RokezzzBlogCategoryListViewComponent),
                    data: {
                        path: 'admin.blog.category',
                        categoryFormPath: 'admin.blog.categoryForm',
                        frontCategoryPath: 'blog.category',
                        blogType: undefined,
                    }
                },
                {
                    path: $localize`:@@adminCategoryFormPath:formularz-kategorii`,
                    loadComponent: () => import('src/app/rokezzz/blog/admin/views/blog/category-form/category-form.component').then(module => module.RokezzzBlogCategoryFormViewComponent),
                    data: {
                        path: 'admin.blog.categoryForm',
                        postListPath: 'admin.blog.category',
                        blogType: undefined,
                    }
                },
                {
                    path: $localize`:@@adminCategoryFormPath:formularz-kategorii` + '/:id',
                    loadComponent: () => import('src/app/rokezzz/blog/admin/views/blog/category-form/category-form.component').then(module => module.RokezzzBlogCategoryFormViewComponent),
                    data: {
                        path: 'admin.blog.categoryForm',
                        postListPath: 'admin.blog.category',
                        blogType: undefined,
                    }
                }] : []),
            ...(moduleConfig.blogHasReview ? [
                {
                    path: $localize`:@@adminReviewListPath:ocena` + '/:id' + '/:title',
                    loadComponent: () => import('src/app/rokezzz/blog/admin/views/blog/review-list/review-list.component').then(module => module.RokezzzBlogReviewListViewComponent),
                    data: {
                        path: 'admin.blog.review',
                    }
                },
            ] : []),
        ]
    },
];
